var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiteracyProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Literacy_Program",
    "data-name": "Literacy Program",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#effbf3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "health-literacy",
    transform: "translate(477.5 192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9934",
    "data-name": "Path 9934",
    d: "M27,37a3,3,0,1,1-3-3A3,3,0,0,1,27,37Z",
    fill: "#23c55e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9935",
    "data-name": "Path 9935",
    d: "M28.408,10.427c-1.376.2-2.826.476-4.408.813-1.582-.337-3.032-.61-4.408-.813,1.245.489,2.51,1.077,3.845,1.721a1,1,0,0,1,.563.9,1,1,0,0,1,.563-.9C25.9,11.5,27.163,10.916,28.408,10.427ZM24,35.4a1.011,1.011,0,0,1-1,1.007v.2a44.872,44.872,0,0,0-17-.022V13.033c.692-.158,1.356-.3,2-.417V10.583c-1.026.184-2.1.412-3.243.687A.991.991,0,0,0,4,12.236V37.775a1.011,1.011,0,0,0,1.2.987,44.273,44.273,0,0,1,18.6.015,1.125,1.125,0,0,0,.384,0,44.271,44.271,0,0,1,18.6-.015,1.012,1.012,0,0,0,1.2-.987V12.236a.991.991,0,0,0-.757-.966C42.1,11,41.026,10.767,40,10.583v2.033c.644.12,1.308.259,2,.417V36.583A44.872,44.872,0,0,0,25,36.6v-.2A1.011,1.011,0,0,1,24,35.4Z",
    fill: "#23c55e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9936",
    "data-name": "Path 9936",
    d: "M9,10.507V33.055H9a.035.035,0,0,0,.007.008.064.064,0,0,0,.053.013c5.34-.98,9.352.219,13.915,2.329l.008,0h0a.027.027,0,0,0,.012,0l0,0h0V13.048C18.021,10.644,14.266,9.167,9,10.507Zm14,2.542ZM8.474,8.577c6.019-1.541,10.347.232,15.4,2.671A2,2,0,0,1,25,13.047V35.4a2.015,2.015,0,0,1-2.864,1.82c-4.38-2.025-7.949-3.052-12.715-2.177A2.042,2.042,0,0,1,7,33.055V10.492A1.971,1.971,0,0,1,8.474,8.577Z",
    fill: "#23c55e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9937",
    "data-name": "Path 9937",
    d: "M39,10.507V33.055h0a.034.034,0,0,1-.007.008.064.064,0,0,1-.053.013c-5.34-.98-9.352.219-13.915,2.329l-.008,0h0a.027.027,0,0,1-.012,0l0,0h0V13.047C29.979,10.643,33.734,9.167,39,10.507ZM25,13.047Zm14.526-4.47c-6.019-1.541-10.347.232-15.4,2.671A2,2,0,0,0,23,13.048V35.4a2.015,2.015,0,0,0,2.864,1.819c4.38-2.025,7.949-3.052,12.715-2.177A2.042,2.042,0,0,0,41,33.055V10.492A1.971,1.971,0,0,0,39.526,8.577Z",
    fill: "#23c55e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9938",
    "data-name": "Path 9938",
    d: "M32,14a1,1,0,0,1,1,1v8a1,1,0,0,1-2,0V15A1,1,0,0,1,32,14Z",
    fill: "#23c55e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9939",
    "data-name": "Path 9939",
    d: "M32.56,19.34a15.991,15.991,0,0,0-3.582,1.539,1,1,0,1,1-.956-1.757,17.921,17.921,0,0,1,4.031-1.717,14.276,14.276,0,0,1,3.961-.4,1,1,0,1,1-.028,2A12.315,12.315,0,0,0,32.56,19.34ZM11.51,27.5a17.5,17.5,0,0,1,7.632,1.434l.716-1.868A19.457,19.457,0,0,0,11.49,25.5Zm0-5a17.5,17.5,0,0,1,7.632,1.434l.716-1.868A19.457,19.457,0,0,0,11.49,20.5Zm0-5a17.5,17.5,0,0,1,7.632,1.434l.716-1.868A19.457,19.457,0,0,0,11.49,15.5Z",
    fill: "#23c55e",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteracyProgram);
export default __webpack_public_path__ + "static/media/Literacy-Program.14c4d4b1701580cc01d5e0ae5e95d88a.svg";
export { ForwardRef as ReactComponent };